import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PhotoInfoType, ServiceInsightsPhotoObject } from '../../../types/service-insights-export-photo.types';

@Component({
    selector: 'service-insights-photo-gallery-item',
    templateUrl: './service-insights-photo-gallery-item.component.html',
    styleUrls: ['./service-insights-photo-gallery-item.component.scss'],
    standalone: false
})
/**
 * Represents a single photo card in the service insights photo carousel.
 */
export class ServiceInsightsPhotoGalleryItemComponent {
  @Input() photo: PhotoInfoType | undefined = undefined; // Photo specific information
  @Input() photoObject: ServiceInsightsPhotoObject | undefined = undefined; // The overall photo object containing metadata and photo list
  @Input() isExportSelectIcon: boolean = false;
  @Input() isInFocus: boolean = false; // Indicates if the photo is currently in focus in the carousel
  @Input() componentId: string = ''; // Can be removed, doesnt add any functional value

  @Output() selectClick = new EventEmitter<Event>(); // Emitting an object with ID and checked status
  @Output() photoClick = new EventEmitter<void>();

  onSelectClick(event: any): void {
    this.selectClick.emit(event); // Emit the photo URL or any other relevant data
  }

  onPhotoClicked() {
    this.photoClick.emit();
  }
}
